<div class="row invoice-grids">
  <div class="col s12 m12 l12 xl12 remove-default-padding">
    <h2>Invoice</h2>
    <div *ngIf="operators && operators.View">
      <div [hidden]="initialLoading">
        <div>
          <kendo-tabstrip [animate]="true" [tabAlignment]="'justify'" #tabstrip (tabSelect)="onTabSelect($event)"
            [keepTabContent]="true">
            <kendo-tabstrip-tab [title]="tab.tabTitle" [selected]="selectedTab === i"
              *ngFor="let tab of invoiceData let i=index">
              <ng-template kendoTabContent>
                <div class="bottom-margin-10" *ngIf="selectedTab === 0">
                  <span class="k-icon k-i-info"></span> {{config.ScheduleInvoiceMsg}}
                </div>
                <div class="bottom-margin-10" *ngIf="selectedTab === 0">
                  <span class="k-icon k-i-info"></span> {{config.MultipleInvoiceMsg}}
                </div>
                <div *ngIf="tab.data.length > 1; else singleRecord">
                  <div *ngIf="tab.show">
                    <kendo-grid #grid [kendoGridBinding]="tab.data" id="invoice-grid"
                      [kendoGridExpandDetailsBy]="expandDetailsBy" [(expandedDetailKeys)]="expandedDetailKeys"
                      (expandedDetailKeysChange)="expandedDetailKeysChange($event)">
                      <kendo-grid-column field="title" title="title" [headerClass]="{'display-none': true}">
                      </kendo-grid-column>
                      <ng-template kendoGridDetailTemplate let-dataItem [kendoGridDetailTemplateShowIf]="shouldDisplay">
                        <div id="invoice-details-div">
                          <app-invoice-details [invoiceDetails]="dataItem" [reset]="resetSelection" [configTxt]="config"
                            [canSelect]="operators && (operators.Add || operators.Edit) && !noInfo"
                            (selected)="selectionEvent($event)" (dateChange)="onDateChange($event)">
                          </app-invoice-details>
                        </div>
                      </ng-template>
                    </kendo-grid>
                  </div>
                </div>
                <ng-template #singleRecord>
                  <div *ngIf="tab.show" id="single-invoice-details-div">
                    <app-invoice-details [invoiceDetails]="tab.data[0]">
                    </app-invoice-details>
                  </div>
                </ng-template>
              </ng-template>
            </kendo-tabstrip-tab>
          </kendo-tabstrip>
        </div>
        <div class="row popup-div" [hidden]="selectedTab !== 0">
          <div class="col s12 m12 l9 xl10 top-margin-10 popup-note align-center" *ngIf="noInfo">
            {{noInfo}}
          </div>
          <div class="col s12 m12 l3 xl2 align-right" [ngClass]="noInfo ? '' : 'offset-l9 offset-xl10'"
            *ngIf="operators && (operators.Add || operators.Edit)">
            <button kendoButton [disabled]="!enablePayBtn || noInfo" [primary]="true" (click)="showDialog()"
              class="background-red border-red padding-10 margin-10">
              <span *ngIf="!loading" class='k-icon k-i-parameters-unknown'></span>Pay
              <span class="left-padding-5" *ngIf="total !== 0">
                {{negativeAmount(total)}}</span>
              <span *ngIf="loading" class="k-i-loading k-icon"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-notification-loading></app-notification-loading>
<kendo-dialog title="Confirm Payment" (close)="closeDialog('no')" class="app-dialog" [minWidth]="250" [maxWidth]="550"
  *ngIf="openDialog">
  <p class="margin-10 align-left" [innerHTML]="disclaimer"></p>
  <kendo-dialog-actions id="deleteDialogBtn">
    <button kendoButton id="no-delete-schedule" (click)="closeDialog('no')" [disabled]="loading" primary="true">Cancel</button>
    <button kendoButton id="yes-delete-schedule" (click)="closeDialog('yes')" primary="true" [disabled]="loading">
      <span *ngIf="!loading">Confirm</span>
      <span *ngIf="loading" class="k-i-loading k-icon"></span>
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
